import { useSurveyContext } from '../context/useSurveryContext';
import CustomButtonComponent from '../../../components/custom-button/custom-button.component';
import bannerInferior from '../../../assets/png/banner.png';
import styles from '../styles/terminos.module.css';
import { useIdQuestion } from '../hooks/useIdQuestion';
export default function TermsAndConditions() {
	const { setTermsAccepted } = useSurveyContext();
	const id = useIdQuestion();
	return (
		<div
			className={styles['terminos-container']}
			style={{
				backgroundImage: `url(${bannerInferior})`,
				backgroundRepeat: 'no-repeat',
				backgroundPosition: 'bottom center',
				// paddingBottom: '120px',
				backgroundSize: 'auto',
			}}
		>
			<div className={styles['terminos-div']}>
				<h1 className={styles.title}>
					{' '}
					{id === '00008'
						? 'Encuesta de satisfacción'
						: 'Encuesta de Mi Cuenta Infonavit'}
				</h1>
				<div className={styles['terminos-text']}>
					<p className={styles['terminos-text-p']}>
						En el INFONAVIT <span>buscamos mejorar </span>
						siempre la{' '}
						<span className={styles['terminos-text-span']}>
							atención a nuestros derechohabientes
						</span>{' '}
						y ofrecerles productos y servicios de mejor calidad.
					</p>
					<p className={styles['terminos-text-p']}>
						<span>Participa en la siguiente encuesta </span>
						sobre tu experiencia con nosotros.
					</p>
					<p className={styles['terminos-text-p']}>
						Tus respuestas serán tratadas de forma confidencial y conforme a
						nuestro{' '}
						<a
							href="https://portalmx.infonavit.org.mx/wps/portal/infonavit.web/transparencia/aviso-privacidad/"
							target="_blank"
							rel="noopener noreferrer"
							className={styles['terminos-text-link']}
						>
							Aviso de Privacidad
						</a>
					</p>
					<div
						style={{
							width: '108px',
							margin: '0 auto',
						}}
					>
						<CustomButtonComponent
							id="btn-aceptar"
							onClick={() => setTermsAccepted(true)}
							label="Aceptar"
							customStyles="btn-id-aceptar-bc"
						/>
					</div>
				</div>
			</div>
		</div>
	);
}
